<template>
  <div class="spotlight-section__wrapper">
    <div class="spotlight-section__info">
      <h2>IN THE SPOTLIGHT</h2>

      <p class="spotlight-section__description text-body">
        Explore the Global Reach of Finance Magnates & ForexLive. Recognized and
        cited by top financial media, we stand at the forefront of financial
        news and analysis. Discover how our insights and expertise resonate
        across the financial industry, earning us mentions and references from
        some of the most esteemed names in financial journalism.
      </p>

      <div class="spotlight-section__list-and-icon-wrapper">
        <homepage-spotlight-section-list class="spotlight-section__list" />

        <a-visibility hide :from="$breakpoint.tablet">
          <homepage-spotlight-background-icon
            class="spotlight-section__background-wrapper"
          />
        </a-visibility>
      </div>
    </div>

    <a-visibility
      show
      :from="$breakpoint.tablet"
      class="spotlight-section__icon-and-background-wrapper"
    >
      <homepage-spotlight-background-icon />
    </a-visibility>
  </div>
</template>

<script>
import HomepageSpotlightSectionList from '@/components/_homepage/HomepageSpotlightSection/HomepageSpotlightSectionList/index.vue'
import HomepageSpotlightBackgroundIcon from '@/components/_homepage/HomepageSpotlightSection/HomepageSpotlightBackgroundIcon/index.vue'
import { generateServerCacheKey } from '@/plugins/helper'

export default {
  name: 'HomepageSpotlightSection',
  serverCacheKey: () => generateServerCacheKey('HomepageSpotlightSection'),
  components: {
    HomepageSpotlightBackgroundIcon,
    HomepageSpotlightSectionList
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/mixins/grid';

.spotlight-section__wrapper {
  position: relative;
  align-items: flex-start;

  $grid-setup: (
    $columnSetup: (
      $above-desktop-xl: percentage(750px / $desktop-full-hd-container)
        percentage(570px / $desktop-full-hd-container),
      $desktop-sm: percentage(600px / $desktop-sm-container)
        percentage(400px / $desktop-sm-container),
      $tablet: percentage(401px / $tablet-container)
        percentage(377px / $tablet-container),
      $mobile: 100%
    ),
    $columnGapSetup: (
      $above-desktop-xl: 79px,
      $desktop-sm: 40px,
      $tablet: 38px
    )
  );

  @include gridBuilder($grid-setup);

  .spotlight-section__info {
    $margin-bottom: (
      $above-desktop-xl: 58px,
      $desktop-sm: 51px,
      $mobile: 39px
    );

    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
  }

  .spotlight-section__description {
    $margin-top: (
      $above-desktop-xl: 53px,
      $desktop-sm: 26px,
      $mobile: 15px
    );

    $margin-bottom: (
      $mobile: 15px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
  }

  .spotlight-section__list-and-icon-wrapper {
    $grid-setup: (
      $columnSetup: (
        $mobile: percentage(198px / $mobile-container)
          percentage(211px / $mobile-container)
      ),
      $columnGapSetup: (
        $mobile: 9px
      )
    );

    @include gridBuilder($grid-setup);

    @include mobile {
      align-items: center;
    }
  }

  .spotlight-section__list {
    $margin-top: (
      $above-desktop-xl: 63px,
      $desktop-sm: 29px,
      $mobile: 0
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }

  .spotlight-section__icon-and-background-wrapper {
    position: relative;

    $margin-top: (
      $above-desktop-xl: 60px,
      $desktop-sm: 40px,
      $mobile: 8px
    );

    $margin-bottom: (
      $above-desktop-xl: 58px,
      $desktop-sm: 51px,
      $mobile: 39px
    );

    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
    @include setStyleByBreakpoint('margin-top', $margin-top);
  }
}
</style>
